let isInStaticFallbackContext = false;

export function setStaticFallbackContext(value: boolean) {
	isInStaticFallbackContext = value;
}
export function getStaticFallbackContext() {
	return isInStaticFallbackContext;
}
